import { reduxForm } from 'redux-form';
import { connect } from 'react-redux';
import { Form } from './Form';
import { fetchCreateUser } from '@app/src/views/CreateUsers/createUSer/state/createUser/actions';
import * as selectCreateUser from '@app/src/views/CreateUsers/createUSer/state/createUser/selectors';

const Container = reduxForm({
  form: 'createUser',
  onSubmit (fields, dispatch, { url }) {
    dispatch(fetchCreateUser(url, fields));
  }
})(Form);

const mapStateToProps = state => ({
  message: selectCreateUser.getMessage(state),
  isFetching: selectCreateUser.getIsFetching(state),
  sessionRol: selectCreateUser.getSessionRol(state)
});

export const FormContainer = connect(
  mapStateToProps,
  null
)(Container);
